export const TOAST_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const COMMON_MSG = {
  ERROR: {
    GENERIC: 'Something went wrong. Please try again.',
    NETWORK: 'Network error. Please check your connection.',
    TIMEOUT: 'Request timed out. Please try again.',
    UNAUTHORIZED: 'Session expired. Please log in again.',
    FORBIDDEN: 'You do not have permission to perform this action.',
    FAILED_TO_LOAD_DATA: 'Failed to load data',
    FAILED_TO_LOAD_VISITS: 'Failed to load patient visits',
    FAILED_TO_LOAD_VISIT_DATA: 'Failed to load visit data',
    FAILED_TO_LOAD_DASHBOARD: 'Failed to load dashboard data',
    FAILED_TO_LOAD_FORM_OPTIONS: 'Failed to load form options',
    FAILED_TO_LOAD_CAMPS: 'Failed to load camps',
    FAILED_TO_ADD_VISIT: 'Failed to add visit. Please try again.',
    FAILED_TO_ADD_PATIENT: 'Failed to add patient',
    FAILED_TO_UPDATE_VISIT: 'Failed to update patient visit',
    NO_DATA_RETURNED: 'No data returned from server',
  },
  SUCCESS: {
    SAVED: 'Saved successfully',
    UPDATED: 'Updated successfully',
    DELETED: 'Deleted successfully',
    CREATED: 'Created successfully',
    ADDED: 'Added successfully',
  },
  VALIDATION: {
    REQUIRED_FIELDS: 'Please fill all required fields',
    SELECT_USER: 'Please select at least one user',
    SELECT_RECORDS: 'Please select records',
    SELECT_A_USER: 'Please select a user',
    SELECT_A_CAMP: 'Please select a camp',
    SELECT_PATIENT_FIRST: 'Please select a patient first',
    INVALID_EMAIL: 'Please enter a valid email address',
    INVALID_PHONE: 'Please enter a valid phone number',
    INVALID_FILE_TYPE: 'Only JPG, GIF, or PNG files are allowed',
    FILE_SIZE_EXCEEDED: 'File size must not exceed 800KB',
    MEDICINE_NAME_REQUIRED: 'Medicine name is required',
    DOSAGE_REQUIRED: 'Dosage is required',
    MEDICINE_NAME_DOSAGE_REQUIRED: 'Medicine name and dosage are required',
    PATIENT_VISIT_ID_REQUIRED: 'Patient visit ID is required for updating',
    EYE_EXAM_REQUIRED_FIRST: 'Please create an Eye Exam first.',
    TEMPLATE_ID_NOT_FOUND: 'Template id not found.',
  },
  INFO: {
    CHANGES_DISCARDED: 'Changes discarded',
  },
  CONFIRM: {
    DELETE_PRESCRIPTION: 'Are you sure you want to delete this prescription?',
    MAKE_FOLLOWUP: 'Do you want to make a follow up?',
    CONFIRMATION_HEADER: 'Confirmation',
    DELETE_NOTIFICATION: 'Are you sure you want to delete the selected notification(s)?',
  },
};

export const FEATURE_MSG = {
  AUTH: {
    LOGIN_SUCCESS: 'Successfully logged in',
    LOGIN_ERROR: 'Invalid email or password',
    RESET_LINK_SENT: 'Reset link sent successfully',
    PASSWORD_CHANGED: 'Password changed successfully',
    WRONG_PASSWORD: 'Wrong password',
  },
  USER: {
    ADDED: 'User added successfully',
    UPDATED: 'User updated successfully',
    DELETED: 'User deleted successfully',
    ASSIGNED_TO_CAMP: 'User assigned to camp successfully',
    ALREADY_ASSIGNED: 'User is already assigned',
    ROLE_UPDATED: 'Updated user role successfully',
    REMOVED: 'Removed successfully',
  },
  PATIENT: {
    ADDED: 'Patient added successfully',
    UPDATED: 'Patient updated successfully',
    DELETED: 'Patient deleted successfully',
  },
  CAMP: {
    ADDED: 'Camp added successfully',
    UPDATED: 'Camp updated successfully',
    DELETED: 'Camp deleted successfully',
  },
  ORGANIZATION: {
    ADDED: 'Organization added successfully',
    UPDATED: 'Organization updated successfully',
    DELETED: 'Organization deleted successfully',
  },
  NOTIFICATION: {
    SENT: 'Notification sent successfully',
    TEMPLATE_CREATED: 'Template created successfully',
    TEMPLATE_UPDATED: 'Template updated successfully',
    TEMPLATE_DELETED: 'Template deleted successfully',
  },
  VISIT: {
    ADDED: 'Patient visit details added successfully',
    UPDATED: 'Patient visit details updated successfully',
    DELETED: 'Patient visit details deleted successfully',
  },
  ROLE: {
    ADDED: 'Role added successfully',
    UPDATED: 'Role updated successfully',
    PERMISSION_ADDED: 'Permission added to role',
    USER_REMOVED: 'Removed successfully',
    ALREADY_EXISTS:'Role name already exists. Please try with a different name',
  },
  DONOR: {
    ADDED: 'Donor added successfully',
    UPDATED: 'Donor updated successfully',
    DELETED: 'Donor deleted successfully',
    DONATION_ADDED: 'Donation added successfully',
    DONATION_UPDATED: 'Donation updated successfully',
  },
  INVOICE: {
    ADDED: 'Invoice added successfully',
    UPDATED: 'Invoice updated successfully',
  },
  PAYMENT: {
    ADDED: 'Payment added successfully',
  },
  EXAMINATION: {
    SURGERY_ADDED: 'Surgery recommendation added successfully',
    SURGERY_UPDATED: 'Surgery recommendation updated successfully',
    PRESCRIPTION_ADDED: 'Medical prescription added successfully',
    PRESCRIPTION_UPDATED: 'Medical prescription updated successfully',
    PRESCRIPTION_DELETED: 'Prescription deleted successfully',
    PRESCRIPTION_DELETE_FAILED: 'Failed to delete prescription',
    PRESCRIPTION_LOAD_FAILED: 'Failed to load prescriptions',
    GLASSES_ADDED: 'Glasses prescription added successfully',
    GLASSES_UPDATED: 'Glasses prescription updated successfully',
    CLINICAL_INFO_ADDED: 'Clinical information added successfully',
    CLINICAL_INFO_UPDATED: 'Clinical information updated successfully',
    EYE_EXAM_ADDED: 'Eye examination added successfully',
    EYE_EXAM_UPDATED: 'Eye examination updated successfully',
    FOLLOWUP_ADDED: 'Post-surgery follow-up added successfully',
    FOLLOWUP_UPDATED: 'Post-surgery follow-up updated successfully',
  },
  LOGISTICS: {
    STATUS_UPDATED: 'Status updated successfully',
    TRANSPORTATION_SCHEDULED: 'Transportation scheduled successfully',
    FOLLOWUP_ADDED: 'Follow up added successfully',
  },
  SYSTEM_SETTINGS: {
    LOGO_UPLOADED: 'Logo uploaded successfully',
    LOGO_UPLOAD_FAILED: 'Failed to upload logo',
    UPLOAD_LOGO_FIRST: 'Please upload a logo first',
    FILE_TOO_LARGE: 'File size should be smaller than',
    INVALID_FILE_TYPE: 'Please upload a JPG, PNG or SVG file',
    ICO_FILE_TYPE: "Please upload a valid .ico file",
    UPLOAD_AT_LEAST_ONE: 'Please upload at least one file',
    SETTINGS_SAVED: 'Settings saved successfully',
    FULL_LOGO_UPLOADED: 'Full logo uploaded successfully',
    FAVICON_UPLOADED: 'Favicon uploaded successfully',
    LOGIN_LOGO_UPLOADED: 'Login logo uploaded successfully',
    FULL_LOGO_UPLOAD_FAILED: "Failed to upload full logo",
    FAVICON_UPLOAD_FAILED: "Failed to upload favicon",
    LOGIN_LOGO_UPLOAD_FAILED: "Failed to upload login logo",
  },
};

